import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import { ErrorMessage, Field } from "formik";
import React, { useContext } from "react";
import { capitalCase } from "../../utils/services";
import { PopupContext } from "../PopUp/Popup-Context";
import { Select } from "../Select";
import "./BusinessInfoForm.scss";
import { BusinessValue, useBusinessInfo } from "./BusinessInfoWrapper";
import { BusinessType } from "../../EnumValues";

interface BusinessInfoProps {
  businessData?: BusinessValue;
  showCancelButton?: boolean;
}

export const BusinessInfoForm: React.FC<BusinessInfoProps> = ({
  businessData,
  showCancelButton = true,
}) => {
  const { handleSubmit, getFieldProps, setFieldValue, values } =
    useBusinessInfo();
  const { closeModal } = useContext(PopupContext);
  const businessTypeList: string[] = Object.values(BusinessType);

  return (
    <div className="business-info-form">
      <div>
        <div className="business-body-data">
          <fieldset className="business-field-set">
            <legend className="small-title">Business Information:</legend>
            <div className="row">
              <div className="col-md-6">
                <div className="data-field">
                  <label className="input-label">Name</label>
                  <div>
                    <Field
                      className="input-field"
                      name="name"
                      placeholder="Enter name"
                      onChange={(e: any) => {
                        const item = capitalCase(e.target.value);
                        setFieldValue("name", item);
                      }}
                    />
                    <ErrorMessage
                      name={"name"}
                      component="div"
                      className="error"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Email</label>
                <div className="data-field">
                  <Field
                    className="input-field"
                    placeholder="Enter email"
                    {...getFieldProps("email")}
                  />
                  <ErrorMessage
                    name={"email"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Address</label>
                <div className="data-field no-bottom">
                  <Field
                    className="input-field"
                    name={`address`}
                    placeholder="Enter address"
                    onChange={(e: any) => {
                      const item = capitalCase(e.target.value);
                      setFieldValue("address", item);
                    }}
                  />
                  <ErrorMessage
                    name={`address`}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Mobile number</label>
                <div className="data-field">
                  <Field
                    type="tel"
                    maxLength={10}
                    className="input-field"
                    placeholder="Enter mobile number"
                    {...getFieldProps("mobile_no")}
                  />
                  <ErrorMessage
                    name={"mobile_no"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Pan number</label>
                <div className="data-field">
                  <Field
                    type="tel"
                    maxLength={9}
                    className="input-field"
                    placeholder="Enter pan number"
                    {...getFieldProps("pan")}
                  />
                  <ErrorMessage
                    name={"pan"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Registration number</label>
                <div className="data-field">
                  <Field
                    className="input-field"
                    //   name="registration_no"
                    placeholder="Enter registration number"
                    {...getFieldProps("registration_no")}
                  />
                  <ErrorMessage
                    name={"registration_no"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Business type</label>
                <div className="data-field">
                  <Select
                    onChange={(e) => {
                      setFieldValue("business_type", e.target.value);
                    }}
                    name="business_type"
                    value={
                      businessData?.business_type
                        ? businessData?.business_type
                        : values.business_type
                    }
                  >
                    <option value="" key="">
                      --Select--
                    </option>
                    {businessTypeList?.map((opt, optindex) => (
                      <option key={optindex} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Select>
                  <ErrorMessage
                    name={"business_type"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <label className="input-label">Establish Date</label>
                <div>
                  <NepaliDatePicker
                    className="input-field"
                    defaultDate={
                      businessData?.establish_date
                        ? businessData?.establish_date.split("/").join("-")
                        : true
                    }
                    onDateSelect={(value: any) => {
                      setFieldValue("establish_date", value);
                    }}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <label className="input-label">Logo</label>
                <div className="logo-field">
                  <input
                    className="input-field"
                    name="logo"
                    type="file"
                    id="fileInput"
                    accept="image/*"
                    onChange={(e: any) => {
                      const value = e.target.files[0];
                      setFieldValue("logo", value === undefined ? null : value);
                    }}
                  />
                  {/* <ErrorMessage
                    name={"logo"}
                    component="div"
                    className="error"
                  /> */}
                </div>
              </div>
              <div className="col-md-6">
                <label className="input-label">Footer text(Optional)</label>
                <div className="data-field no-bottom">
                  <Field
                    className="input-field"
                    placeholder="Enter footer text"
                    {...getFieldProps("footer_text")}
                  />
                  <ErrorMessage
                    name={"footer_text"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <label className="input-label">Website(Optional)</label>
                <div className="data-field no-bottom">
                  <Field
                    className="input-field"
                    //   name="business_type"
                    placeholder="Enter website url"
                    {...getFieldProps("website")}
                  />
                  <ErrorMessage
                    name={"website"}
                    component="div"
                    className="error"
                  />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="btn-right">
          <div className="d-end">
            {showCancelButton && (
              <div>
                <button
                  className="light-secondary mr-16"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Cancel
                </button>
              </div>
            )}

            <div>
              <button
                className="main-button"
                type="submit"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
